export default {
  GET_LEADERSHIP_LIST_REQUESTED: 'GET_LEADERSHIP_LIST_REQUESTED',
  GET_LEADERSHIP_LIST_SUCCEEDED: 'GET_LEADERSHIP_LIST_SUCCEEDED',
  GET_LEADERSHIP_LIST_FAILED: 'GET_LEADERSHIP_LIST_FAILED',
};
